window.ORDER_PAGE_PRICING_HELPERS = {
    isShowAnyOperator(opt, cCode) {
        let operators = {}

        if (this.pricesByCountry && this.pricesByCountry[cCode] && this.pricesByCountry[cCode][opt]) {
            operators = this.pricesByCountry[cCode][opt]
        } else if (this.pricesByService && this.pricesByService[opt] && this.pricesByService[opt][cCode]) {
            operators = this.pricesByService[opt][cCode]
        }

        let operatorsAmount = {}

        if (this.amountByCountry && this.amountByCountry[cCode] && this.amountByCountry[cCode][opt]) {
            operatorsAmount = this.amountByCountry[cCode][opt]
        } else if (this.amountByService && this.amountByService[opt] && this.amountByService[opt][cCode]) {
            operatorsAmount = this.amountByService[opt][cCode]
        }

        // `Any` is the SMSPVA aggregate (Total_XX). Donor operators are rendered
        // in a separate section and must not influence whether that aggregate is
        // meaningful or whether SMSPVA prices are considered equal.
        const smsPvaOperators = Object.fromEntries(
            Object.entries(operators).filter(([operator]) => !this.isExternalAmountOperator(operator, cCode))
        )
        const availableOperators = Object.fromEntries(
            Object.entries(operatorsAmount).filter(([operator, value]) =>
                value !== 0 && !this.isExternalAmountOperator(operator, cCode)
            )
        )
        const availableOperatorsValuesArr = Object.values(availableOperators)

        if (availableOperators.hasOwnProperty('Total_' + cCode) && availableOperatorsValuesArr.length == 2) {
            if (availableOperatorsValuesArr[0] == availableOperatorsValuesArr[1] && !availableOperators.hasOwnProperty('Other_' + cCode)) {
                return false
            }
            return true
        }

        const values = Object.values(smsPvaOperators)
            .map((price) => this.normalizePrice(price))
            .filter((price) => price !== null)

        if (!values.length) {
            return false
        }

        const first = values[0]

        return values.every((val) => val === first)
    },

    getHideOperators(data) {
        if (!data || data.length <= 0) return false

        for (const key in data) {
            if (data[key] <= 0) {
                return true
            }
        }

        return false
    },

    getNumberHandlerInterlayer(cCode, service, operator) {
        if (!cCode || !operator || !service) return

        if (!this.isPriceAvailable(service, cCode, operator)) {
            this.notifyUser($L('ords.country_no_nums'), 'error')
            return
        }

        this.selectedOperator = operator
        this.currServOpt = service
        this.currentCountry = cCode
        this.getNumberHandler(cCode)
    },

    operatorNameWithoutSuffix(operator) {
        if (!operator) return operator

        const operatorArr = operator.split('_')
        return operatorArr[0]
    },

    filterCountryTop() {
        this.countrySortedFavoritesTop = this.allCountries.slice(0, 18)

        if (this.countrySortedFavoritesTop && this.favoritesCountry) {
            for (let i = 0; i < this.favoritesCountry.length; i++) {
                let checkfavCountInArr = null
                for (let j = 0; j < this.countrySortedFavoritesTop.length; j++) {
                    if (this.countrySortedFavoritesTop[j].shortname && this.countrySortedFavoritesTop[j].shortname == this.favoritesCountry[i]) {
                        checkfavCountInArr = j
                    }
                }
                if (checkfavCountInArr != null) {
                    const el = this.countrySortedFavoritesTop.splice(checkfavCountInArr, 1)
                    this.countrySortedFavoritesTop.unshift(el[0])
                } else {
                    this.countrySortedFavoritesTop.unshift(this.getCountryBySN(this.favoritesCountry[i]))
                }
            }
        }

        if (this.countrySortedFavoritesTop.length > 18) {
            this.countrySortedFavoritesTop = this.countrySortedFavoritesTop.slice(0, 18)
        }
    },

    getPriceOperator(country, opt, operator) {
        if (!country || !opt || !operator) {
            return 0
        }

        if (operator == 'Total_' + country) {
            return this.getDisplayPrice(opt, country, operator) || 0
        }

        return this.getDisplayPrice(opt, country, operator) || 0
    },

    gotSms(order) {
        let price = order.price || this.getPriceOperator(order.country, order.opt, order.operator)
        price = isNaN(Number(price)) ? 0 : Number(price)

        if (price) {
            this.balance -= price
        }

        if (window.gtag !== undefined) {
            gtag('event', 'buy_act', { value: price, currency: 'USD' })

            gtag('event', 'conversion', {
                send_to: 'AW-16617902989/8sGcCPyqn7wZEI2nhPQ9',
                value: price,
                currency: 'USD',
            })
        }
    },
}
